// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"179":"components","884":"admin","966":"login"}[chunkId] || chunkId) + "-legacy." + {"29":"1ab73f95","179":"45da8611","246":"d248eb2f","320":"56588d5c","488":"2f495460","582":"adb0ee51","874":"05c67a7b","884":"f2e0ad5e","966":"4b8170cc","983":"c185edaa"}[chunkId] + ".js";
};